import request from "../utils/fetch";

export function getList(data) {
  return request({
    url: "/sysMessage/getList",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}
export function deleteMessage(data) {
  return request({
    url: "/sysMessage/delete",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}
export function addSysMsg(data) {
  return request({
    url: "/sysMessage/addSysMsg",
    method: "post",
    requestBody: "body",
    loading: true,
    data: data,
  });
}

// 实时监听最新消息
export function newMsg(data) {
  return request({
    url: "/public/notice/enterprise/popup",
    method: "get",
    requestBody: "query",
    loading: false,
    params: data,
  });
}
